import styled from "@xstyled/styled-components";

export const PageWrapper = styled.section`
  margin: 0;
  padding-bottom: 4xl;
`;
